export default {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  IRPROTOCOLS: '/ir-protocols',
  CHRACTERISTICS: '/ac-models'
};
